<template>
    <div>
        <div class="fin-columns-2">
            <div class="fin-text-primary md:fin-text-right fin-font-semibold">Current Stage:</div>
            <div
                v-if="(Ambition.isAmbition() && _.get(application, 'is_insurance_deal') !== 1) || isReferrer || isAcrReferrer">
                <div class="fin-text-secondary md:fin-text-left fin-font-semibold">{{ currentStage }}</div>
            </div>
            <div v-else-if="Ambition.isIgnition() || _.get(application, 'is_insurance_deal') === 1">
                <el-select class="fin-w-full" size="mini" v-model="currentStatus" filterable @change="changeStatus">
                    <el-option v-for="item in _.get(options, 'applicationStatuses')"
                               :key="item.id"
                               :label="item.name"
                               :value="item.id">
                    </el-option>
                </el-select>
            </div>
        </div>
        <div v-if="currentStage !== 'Completed'" class="fin-columns-2 fin-mt-2">
            <div class="fin-text-primary md:fin-text-right fin-font-semibold">Next Stage:</div>
            <div class="fin-text-secondary md:fin-text-left fin-font-semibold">{{ nextStage }}</div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex"

export default {
    name: "AppStages",
    props: {
        appInitData: {
            required: false,
            type: Object,
        },
        dropDownOptions: {
            required: false,
            type: Object,
        }
    },
    data() {
        return {
            application: null,
            options: null
        }
    },
    computed: {
        ...mapGetters({
            app: "appStore/application/get",
            storeOptions: "appStore/options/get",
            isReferrer: "appStore/auth/user/isReferrer",
            isAcrReferrer: "appStore/auth/user/isAcrReferrer",
        }),
        currentStatus: {
            get() {
                return _.get(this.application, 'application_status_id')
            },
            set(status) {
                _.get(this.application, 'application_status_id') ? this.application.application_status_id = status : this.app.application_status_id = status
            }
        },
        currentStage() {
            if (_.isEmpty(_.get(this.options, 'applicationStatuses'))) return ""

            let currentStage = _.get(this.options, 'applicationStatuses').find((status) => status.id == this.currentStatus)
            if (!_.isEmpty(currentStage)) {
                return currentStage.name
            }
            return "New"
        },
        nextStage() {
            if (_.isEmpty(_.get(this.options, 'applicationStatuses'))) return ""
            let currentStage = _.get(this.options, 'applicationStatuses').find((status) => status.id == this.currentStatus)
            let nextStageId = !_.isEmpty(currentStage) ? currentStage.id + 1 : 2
            let nextStage = _.get(this.options, 'applicationStatuses').find((status) => status.id == nextStageId)
            if (!_.isEmpty(nextStage)) {
                return nextStage.name
            }
        },
        currentStatusDetails() {
            return _.get(this.options, 'applicationStatuses').find((status, index) => status.id == this.currentStatus)
        }
    },
    watch: {
        'app': {
            handler(val) {
                if (_.get(val, 'id')) {
                    this.application = val
                }
            },
            immediate: true,
            deep: true
        },
        'appInitData': {
            handler(val) {
                if (_.get(val, 'id')) {
                    this.application = val
                }
            },
            immediate: true,
            deep: true
        },
        'storeOptions': {
            handler(val) {
                if (_.get(val, 'applicationStatuses')) {
                    this.options = val
                }
            },
            immediate: true,
            deep: true
        },
        'dropDownOptions': {
            handler(val) {
                if (_.get(val, 'applicationStatuses')) {
                    this.options = val
                }
            },
            immediate: true,
            deep: true
        }
    },
    mounted() {},
    methods: {
        changeStatus() {
            const details = this.currentStatusDetails

            const {label, value, stateName} = details

            // Save to store (via insanity +1 -1 +2...)
            this.$store.dispatch('statusIndicators/initialiseStatus', {
                status_id: value + 1
            })

            this.$store.dispatch("statusIndicators/changeStatus", {
                stage: stateName,
                value,
                token: this.$store.getters.token,
                appId: this.$store.getters.initAppData.id
            })

            this.saveStatusChange()
            this.gotoCurrentTab()
        },

        saveStatusChange() {
            // PUT: applications/{application}/changeStatus
            const application_status_id = this.currentStatus
            return axios({
                method: 'put',
                url: `/api/applications/${this.application.id}/changeStatus`,
                headers: {Authorization: "Bearer " + this.$store.getters.token},
                data: {application_status_id}
            })
        },

        gotoCurrentTab() {
            // API Method
            const details = this.currentStatusDetails
            const {label, value, stateName} = details
            const path = Ambition.Router.findRouteByStatus(label, this.application.id)
            //
            if (path && this.$route.path !== path) this.$router.push({path})
        }
    },
}
</script>

<style lang="scss" scoped></style>
